import { render, staticRenderFns } from "./CtaExtensionBanner.vue?vue&type=template&id=2eeff0c8&scoped=true"
import script from "./CtaExtensionBanner.vue?vue&type=script&lang=js"
export * from "./CtaExtensionBanner.vue?vue&type=script&lang=js"
import style0 from "./CtaExtensionBanner.vue?vue&type=style&index=0&id=2eeff0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeff0c8",
  null
  
)

export default component.exports